import {
  LayoutDashboard,
  Users,
  School,
  History,
  Settings,
  User,
  Mail,
  Menu,
  ArrowLeftRight,
  Apple,
} from 'lucide-react';

const teacherTabsBase = [
  { id: 'home', labelKey: 'navHome', icon: LayoutDashboard },
  { id: 'more', labelKey: 'navMore', icon: Menu },
];

const teacherTabsMulti = [
  { id: 'home', labelKey: 'navHome', icon: LayoutDashboard },
  { id: 'switchClass', labelKey: 'navSwitchClass', icon: ArrowLeftRight },
  { id: 'more', labelKey: 'navMore', icon: Menu },
];

/** Shown in bottom nav on phone (keep ≤4 items) */
export function getBottomTabsForRole(role, { teacherClassCount = 0 } = {}) {
  if (role === 'teacher' && teacherClassCount > 1) {
    return teacherTabsMulti;
  }
  if (role === 'teacher') {
    return teacherTabsBase;
  }
  return bottomTabsByRole[role] || [];
}

export const bottomTabsByRole = {
  teacher: teacherTabsBase,
  head: [
    { id: 'report', labelKey: 'navReport', icon: LayoutDashboard },
    { id: 'classes', labelKey: 'navClasses', icon: School },
    { id: 'teachers', labelKey: 'navTeachers', icon: Users },
    { id: 'more', labelKey: 'navMore', icon: Menu },
  ],
  admin: [
    { id: 'schools', labelKey: 'navSchools', icon: School },
    { id: 'testers', labelKey: 'navTesters', icon: Mail },
    { id: 'settings', labelKey: 'navSettings', icon: Settings },
    { id: 'account', labelKey: 'navAccount', icon: User },
  ],
};

/** Full nav on desktop */
export function getAllTabsForRole(role, { teacherClassCount = 0 } = {}) {
  if (role === 'teacher' && teacherClassCount > 1) {
    return [
      { id: 'home', labelKey: 'home', icon: LayoutDashboard },
      { id: 'switchClass', labelKey: 'navSwitchClass', icon: ArrowLeftRight },
      { id: 'history', labelKey: 'history', icon: History },
      { id: 'settings', labelKey: 'settings', icon: Settings },
      { id: 'account', labelKey: 'account', icon: User },
    ];
  }
  if (role === 'teacher') {
    return allTabsByRole.teacher;
  }
  return allTabsByRole[role] || [];
}

export const allTabsByRole = {
  teacher: [
    { id: 'home', labelKey: 'home', icon: LayoutDashboard },
    { id: 'history', labelKey: 'history', icon: History },
    { id: 'settings', labelKey: 'settings', icon: Settings },
    { id: 'account', labelKey: 'account', icon: User },
  ],
  head: [
    { id: 'report', labelKey: 'report', icon: LayoutDashboard },
    { id: 'nutrition', labelKey: 'navNutrition', icon: Apple },
    { id: 'classes', labelKey: 'classesTitle', icon: School },
    { id: 'teachers', labelKey: 'teachersTitle', icon: Users },
    { id: 'history', labelKey: 'history', icon: History },
    { id: 'settings', labelKey: 'settings', icon: Settings },
    { id: 'account', labelKey: 'account', icon: User },
  ],
  admin: bottomTabsByRole.admin,
};

export const secondaryTabsByRole = {
  teacher: ['history', 'settings', 'account'],
  head: ['nutrition', 'history', 'settings', 'account'],
  admin: [],
};

export const moreMenuItemsByRole = {
  head: [
    { id: 'nutrition', labelKey: 'navNutrition', descKey: 'moreNutritionDesc', icon: Apple },
    { id: 'history', labelKey: 'history', descKey: 'moreHistoryDesc', icon: History },
    { id: 'settings', labelKey: 'settings', descKey: 'moreSettingsDesc', icon: Settings },
    { id: 'account', labelKey: 'account', descKey: 'moreAccountDesc', icon: User },
  ],
  teacher: [
    { id: 'history', labelKey: 'history', descKey: 'moreHistoryDesc', icon: History },
    { id: 'settings', labelKey: 'settings', descKey: 'moreSettingsDesc', icon: Settings },
    { id: 'account', labelKey: 'account', descKey: 'moreAccountDesc', icon: User },
  ],
};

/** @deprecated use bottomTabsByRole / allTabsByRole */
export const tabsByRole = allTabsByRole;
